import { jsonApi } from '@models/jsonApi';

jsonApi.define('destination-test-sandbox', {
  code: '',
  event: '',
  settings: {
    parameters: '',
  },
});
